module.exports = __webpack_public_path__ + "static/media/1.ffcc1e5b.png";